<template>
	<button :id="element.attributes.id" :ref="element.attributes.id" :class="element.attributes.classes"
		@click="doAction(element)"
		@keyup.enter="doKeyUpAction(element)" :style="element.styles">
		{{ element.text }}
	</button>
</template>

<script lang="ts">
import { Container } from "@/types/customPage";
import { defineComponent, PropType } from "vue";
import { doActionHelper } from "@/utils/action";

export default defineComponent({
	props: {
		element: {
			type: Object as PropType<Container>,
			required: true,
		},
	},
	methods: {
		gotoPage(page: string) {
			this.$router
				.push({
					path: page,
				})
				.catch((err) => {
					console.log(err);
				});
		},
		doAction(container: Container) {
			doActionHelper(container);
		},
		doKeyUpAction(container: Container) {
			doActionHelper(container, true)
		},
	}
});
</script>

<style scoped lang="scss"></style>
